export enum TranscriptionServiceType {
	Manual = 'Manual',
	Vbrick = 'Vbrick',
	VoiceBase = 'VoiceBase'
}
